export default __webpack_public_path__ + "f8995e3055fc877ce17c827e9b767cc2.png";